// extracted by mini-css-extract-plugin
module.exports = {"missionHeading":"mission-heading_missionHeading__bm49V"};